module.exports = __webpack_public_path__ + "img/battery-slash.a096eac8.svg";